import { render } from "./Page18.vue?vue&type=template&id=16a82e6b"
import script from "./Page18.vue?vue&type=script&lang=js"
export * from "./Page18.vue?vue&type=script&lang=js"

import "./Page18.vue?vue&type=style&index=0&id=16a82e6b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__